import React from 'react';
import GoogleAuthHandler from './GoogleAuthHandler';
import useAuth from '../hooks/useAuth';
import Login from '../pages/LoginPage';

const AuthHandler = ({ onSuccess, children }) => {
  const { ctxUser } = useAuth();

  if (!ctxUser.isAuthenticated) {
    return (
      <>
        <GoogleAuthHandler onSuccess={onSuccess} useOneTap={true} />
        <Login onSuccess={onSuccess} />
      </>
    );
  }

  return children;
};

export default AuthHandler;
